import { Routes } from '@angular/router';
import { LoginPageComponent } from './pages/login-page.component';
import { CashPageComponent } from './pages/cash-page.component';
import { RecentOrdersPageComponent } from './pages/recent-orders-page.component';
import { SalePageComponent } from './pages/sale-page.component';
import { SettingsPageComponent } from './pages/settings-page.component';
import { WorkspacePageComponent } from './pages/workspace-page.component';
import { RepairsPageComponent } from './pages/repairs-page.component';
import { RepairNewPageComponent } from './pages/repair-new-page.component';
import { RepairDetailPageComponent } from './pages/repair-detail-page.component';
import { RepairPaymentPageComponent } from './pages/repair-payment-page.component';
import { CashRegisterPageComponent } from './pages/cash-register-page.component';
import { authGuard, cashGuard, entryGuard, loginGuard, posGuard, repairsGuard } from './operation.guards';

export const routes: Routes = [
  { path: '', pathMatch: 'full', component: LoginPageComponent, canActivate: [entryGuard] },
  { path: 'login', component: LoginPageComponent, canActivate: [loginGuard] },
  { path: 'workspace', component: WorkspacePageComponent, canActivate: [authGuard] },
  { path: 'cash-register', component: CashRegisterPageComponent, canActivate: [authGuard] },
  { path: 'pos', component: SalePageComponent, canActivate: [posGuard] },
  { path: 'pos/checkout', component: SalePageComponent, canActivate: [posGuard], data: { checkout: true } },
  { path: 'pos/recent', component: RecentOrdersPageComponent, canActivate: [posGuard] },
  { path: 'cash-session', component: CashPageComponent, canActivate: [cashGuard] },
  { path: 'repairs', component: RepairsPageComponent, canActivate: [repairsGuard] },
  { path: 'repairs/new', component: RepairNewPageComponent, canActivate: [repairsGuard] },
  { path: 'repairs/:uuid/payment', component: RepairPaymentPageComponent, canActivate: [repairsGuard] },
  { path: 'repairs/:uuid', component: RepairDetailPageComponent, canActivate: [repairsGuard] },
  { path: 'sale', redirectTo: 'pos', pathMatch: 'full' },
  { path: 'cash', redirectTo: 'cash-session', pathMatch: 'full' },
  { path: 'recent', redirectTo: 'pos/recent', pathMatch: 'full' },
  { path: 'settings', component: SettingsPageComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: 'workspace' },
];
